import React from 'react';
import { Box, Typography } from '@mui/material';

export default function SectionHeader({ icon, title, subtitle, right }) {
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            mb: 1.5,
            flexWrap: 'wrap',
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                {icon && (
                    <Box sx={{
                        width: 34, height: 34, borderRadius: 2,
                        background: 'linear-gradient(135deg, rgba(96,165,250,0.22), rgba(168,85,247,0.18))',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        color: '#a5b4fc',
                    }}>{icon}</Box>
                )}
                <Box>
                    <Typography sx={{ fontSize: { xs: 15, sm: 16 }, fontWeight: 700, letterSpacing: 0.2, lineHeight: 1.1 }}>{title}</Typography>
                    {subtitle && <Typography sx={{ fontSize: 11.5, opacity: 0.65, mt: 0.25 }}>{subtitle}</Typography>}
                </Box>
            </Box>
            {right}
        </Box>
    );
}
